export default __webpack_public_path__ + "static/media/pending-consent-icon.553daf5f.svg";